export const INITIATOR='initiator'
export const RECIPIENT='recipient'